import { emptySplitApi } from "./index";

export const customProfilesApi = emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
        getCustomProfilePagedList: builder.mutation({
            query: (model) => ({
                url:
                    `api/v1/foundation-service/custom-profile?` +
                    `pageNumber=${model?.pageNumber || 0}` +
                    `&pageSize=${model?.pageSize || ""}` +
                    `&orderField=${model?.orderField || "mainType"}` +
                    `&orderDirection=${model?.orderDirection || "asc"}` +
                    `&searchText=${model?.searchText || ""}` +
                    `&mainType=${model?.mainType || ""}`,
                method: "GET",
            }),
        }),
        getCustomProfile: builder.query({
            query: (id) => ({
                url: `api/v1/foundation-service/custom-profile/${id}`,
                method: "GET",
            }),
        }),
        searchByCustomProfilePagedList: builder.mutation({
            query: (model) => ({
                url:`api/v1/foundation-service/custom-profile/search-by-custom-profile`,
                method: "POST",
                body: model,
            }),
        }),
        importProfiles: builder.mutation({
            query: (model) => ({
                url: `api/v1/foundation-service/custom-profile/import`,
                method: "POST",
                body: model,
            }),
        }),
        addProfile: builder.mutation({
            query: (model) => ({
                url: `api/v1/foundation-service/custom-profile`,
                method: "POST",
                body: model,
            }),
        }),
        editProfile: builder.mutation({
            query: (model) => ({
                url: `api/v1/foundation-service/custom-profile/${model.id}`,
                method: "PUT",
                body: model.body,
            }),
        }),
        deleteProfile: builder.mutation({
            query: (model) => ({
                url: `api/v1/foundation-service/custom-profile/bulk`,
                method: "DELETE",
                body: model,
            }),
        }),
        getDefaultFieldDefinitions: builder.query({
            query: (mainType) => ({
                url: `api/v1/foundation-service/custom-profile/default-fields?mainType=${mainType}`,
                method: "GET",
            }),
        }),
        getDefaultFieldDefinitionsTrigger: builder.mutation({
            query: (mainType) => ({
                url: `api/v1/foundation-service/custom-profile/default-fields?mainType=${mainType}`,
                method: "GET",
            }),
        }),
        validateImportProfiles: builder.mutation({
            query: (model) => ({
                url: `api/v1/foundation-service/custom-profile/validate-import-profiles`,
                method: "POST",
                body: model,
            }),
        }),
        getCustomProfileProvinceOrState: builder.mutation({
            query: () => ({
                url: `api/v1/foundation-service/custom-profile/province-or-state`,
                method: "GET",
            }),
        }),
    }),
});

export const {
    useGetCustomProfilePagedListMutation,
    useGetCustomProfileQuery,
    useImportProfilesMutation,
    useAddProfileMutation,
    useEditProfileMutation,
    useDeleteProfileMutation,
    useGetDefaultFieldDefinitionsQuery,
    useGetDefaultFieldDefinitionsTriggerMutation,
    useValidateImportProfilesMutation,
    useSearchByCustomProfilePagedListMutation,
    useGetCustomProfileProvinceOrStateMutation
} = customProfilesApi;
